(() => {
  const sortByNumberAsc = (a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    // a must be equal to b
    return 0;
  };

  function initVRPlayer(player) {
    player.vr({ projection: '360_LR' });
    player.vr().init();
    player.vr().camera.aspect = (2 * 16) / 9;
    player.vr().camera.updateProjectionMatrix();
  }
  const players = [];
  let activePlayer;
  let orientationChangedAtLeastOnce = false;
  const plyrURL = `${window.swinger.config.assetsBase}/plyr/plyr${!window.swinger.supportsModules ? '.es5' : '.min'}.js?v=${window.swinger.config.version}`;
  const plyrVrURL = `${window.swinger.config.assetsBase}/plyr/plyr-vr.min.js?v=${window.swinger.config.version}`;
  const featureTestingVideoElem = document.createElement('video');
  const canPlayType = (type) => featureTestingVideoElem.canPlayType(type);
  const blankVideo = 'data:video/mp4;base64,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';

  window.swinger.players = players;

  window.swinger.i18n()
    .then((i18n) => {
      const getPlayButtonText = (itemNumber, type = 'trailer') => {
        let key = `ui.video-player.play${type ? `.${type}` : ''}`;
        const isClip = itemNumber && itemNumber.indexOf('AMA') === 0;
        const isScene = itemNumber && itemNumber.indexOf('-') > -1;
        const itemOwnState = window.swinger.user.getItemOwnState(itemNumber);
        const secondsInHour = 3600;
        const secondsInMinute = 60;
        let time;

        switch (true) {
          default:
            return i18n(key, {
              number: '',
            });

          case itemOwnState.status === 'purchased' && isClip:
            key = 'ui.video-player.play.clip';
            break;

          case itemOwnState.status === 'purchased':
            key = `ui.video-player.play.${isScene ? 'scene' : 'movie'}`;
            break;

          case itemOwnState.status === 'rented' && !!itemOwnState.rentalEndTimestamp: {
            const remainingSeconds = itemOwnState.rentalEndTimestamp - Math.ceil((new Date()).getTime() / 1000);
            const hours = Math.floor(remainingSeconds / secondsInHour);
            const minutes = Math.floor((remainingSeconds % secondsInHour) / secondsInMinute);
            time = i18n(hours > 0 ? 'ui.duration.full' : 'ui.duration.minutes', {
              hours,
              minutes,
            });
            key = `ui.video-player.play.${isScene ? 'scene' : 'movie'}.remainingRentPeriod`;
          }
            break;

          case itemOwnState.status === 'rented':
            key = `ui.video-player.play.${isScene ? 'scene' : 'movie'}.startRentPeriod`;
            break;
        }

        return i18n(key, {
          time,
          number: '',
        });
      };

      const getItemMediaMetadata = (options) => {
        const wrapper = options.video.closest('.swinger-video-player');
        const itemNumber = wrapper.getAttribute('data-itemnumber');

        if (itemNumber && !options.video.getAttribute('data-metadata-title')) {
          return window.swinger.api.getItemDetails(itemNumber)
            .then((itemData) => {
              const item = itemData[0];
              const language = window.swinger.config.language;

              if (!item) {
                return {};
              }

              return {
                title: item.name[language] ? item.name[language] : item.name.en,
                // eslint-disable-next-line no-nested-ternary
                artist: item.studio ? item.studio.name : (item.amateur ? item.amateur.name : undefined),
                artwork: item.image ? [window.swinger.user.isLoggedIn() ? item.image.default : item.image.censored] : undefined,
              };
            });
        }
        return Promise.resolve({
          title: options.video.getAttribute('data-metadata-title') || undefined,
          artist: options.video.getAttribute('data-metadata-artist') || undefined,
          artwork: options.video.getAttribute('data-metadata-artwork') ? [options.video.getAttribute('data-metadata-artwork')] : undefined,
        });
      };

      const initPlayer = (options) => getItemMediaMetadata(options).then((mediaMetadata) => {
        try {
          const controls = ['play-large', 'progress', 'rewind', 'play', 'fast-forward', 'current-time', 'duration', 'mute', 'volume', 'captions'];

          if (options.qualities && options.qualities.length) {
            controls.push('settings');
          }

          controls.push('airplay');
          controls.push('fullscreen');

          const wrapper = options.video.closest('.swinger-video-player');
          const itemNumber = wrapper.getAttribute('data-itemnumber');
          const itemOwnState = window.swinger.user.getItemOwnState(itemNumber);
          const plyrSavedSettings = window.swinger.storage.get('swinger-plyr') || {};
          const plyrOptions = {
            debug: false && window.swinger.config.environment !== 'prod',
            iconUrl: `${window.swinger.config.assetsBase}/plyr/plyr.svg?v=${window.swinger.config.version}`,
            previewThumbnails: options.thumbnailSource && options.thumbnailSource.src ? {
              enabled: true,
              src: options.thumbnailSource.src,
            } : {
              enabled: false,
            },
            mediaMetadata,
            autopause: true,
            autoplay: !!options.video.autoplay,
            blankVideo,
            invertTime: false,
            keyboard: { focused: false, global: false },
            controls,
            volume: plyrSavedSettings.volume ? Number(plyrSavedSettings.volume) : 1,
            muted: !!options.video.muted,
            resetOnEnd: true,
            seekTime: 10,
            speed: {
              selected: 1,
              options: [0.5, 1, 2, 4],
            },
            fullscreen: {
              enabled: true,
              fallback: true,
              iosNative: true,
              container: null,
            },
            i18n: [
              'restart',
              'rewind',
              'pause',
              'fastForward',
              'seek',
              'seekLabel',
              'played',
              'buffered',
              'currentTime',
              'duration',
              'volume',
              'mute',
              'unmute',
              'enableCaptions',
              'disableCaptions',
              'download',
              'enterFullscreen',
              'exitFullscreen',
              'frameTitle',
              'captions',
              'settings',
              'pip',
              'menuBack',
              'speed',
              'normal',
              'quality',
              'loop',
              'start',
              'end',
              'all',
              'reset',
              'disabled',
              'enabled',
              'advertisement',
            ].reduce((translations, key) => {
              translations[key] = i18n(`ui.video-player.${key}`);

              return translations;
            }, {
              play: getPlayButtonText(itemNumber, options.type),
              qualityBadge: {
                2160: '4K',
                1440: 'HD',
                1080: 'HD',
                720: 'HD',
                576: 'SD',
                404: 'SD',
                480: 'SD',
                270: 'SD',
              },
            }),
          };

          wrapper.classList[itemOwnState === false ? 'remove' : 'add']('swinger-video-player--is-owned');
          wrapper.classList[itemOwnState.status === 'purchased' ? 'add' : 'remove']('swinger-video-player--is-bought');
          wrapper.classList[itemOwnState.status === 'rented' ? 'add' : 'remove']('swinger-video-player--is-rented');
          wrapper.classList[itemOwnState.status === 'blocked' ? 'add' : 'remove']('swinger-video-player--is-blocked');

          if (options.qualities && options.qualities.length) {
            options.qualities.sort(sortByNumberAsc);
            options.qualities.reverse();

            Object.assign(plyrOptions, {
              settings: ['captions', 'quality', 'speed'],
              quality: {
                default: options.qualities[0],
                options: options.qualities,
              },
            });
          }

          const player = new window.Plyr(options.video, plyrOptions);

          let hudElem;
          let hudTimer;
          let skipTimer;
          let previousEvent;

          const originalSkipMethods = {
            rewind: player.rewind,
            forward: player.forward,
          };
          let direction;

          Object.keys(originalSkipMethods).forEach((method) => {
            player[method] = (seconds) => {
              if (direction !== method) {
                player.config.seekTime = 10;
              }

              previousEvent = method;

              const currentSeekTime = seconds || player.config.seekTime;

              hudElem = hudElem || document.createElement('span');
              player.elements.container.appendChild(hudElem);
              player.elements.container.classList.remove('plyr--show-hud');
              window.setTimeout(() => {
                player.elements.container.classList.add('plyr--show-hud');
                hudElem.className = `plyr__hud plyr__hud--${method}`;
                hudElem.textContent = `${currentSeekTime}`;
              }, 50);

              window.clearTimeout(hudTimer);
              window.clearTimeout(skipTimer);
              hudTimer = window.setTimeout(() => {
                player.elements.container.classList.remove('plyr--show-hud');
                previousEvent = '';
              }, 1000);
              skipTimer = window.setTimeout(() => {
                originalSkipMethods[method].apply(player, [currentSeekTime]);
                player.config.seekTime = 10;
                direction = undefined;
              }, 300);
              player.config.seekTime += 10;
              direction = method;
            };
          });

          let previousSpeed = player.speed;

          player.on('ratechange', (e) => {
            const player = e.detail.plyr;

            if (previousSpeed === player.speed) {
              return;
            }

            previousEvent = 'ratechange';

            previousSpeed = player.speed;
            hudElem = hudElem || document.createElement('span');
            player.elements.container.appendChild(hudElem);
            player.elements.container.classList.remove('plyr--show-hud');
            window.setTimeout(() => {
              player.elements.container.classList.add('plyr--show-hud');
              hudElem.className = 'plyr__hud plyr__hud--speedchange';
              hudElem.innerHTML = `${player.speed}&times;`;
            }, 50);

            window.clearTimeout(hudTimer);
            hudTimer = window.setTimeout(() => {
              player.elements.container.classList.remove('plyr--show-hud');
              previousEvent = '';
            }, 1000);
          });

          player.on('volumechange', (e) => {
            const player = e.detail.plyr;

            if (previousEvent !== 'volumechange') {
              hudElem = hudElem || document.createElement('span');
              player.elements.container.appendChild(hudElem);
              player.elements.container.classList.remove('plyr--show-hud');
            }

            window.setTimeout(() => {
              player.elements.container.classList.add('plyr--show-hud');

              hudElem.textContent = '';
              if (player.muted) {
                hudElem.className = 'plyr__hud plyr__hud--mute';
                hudElem.style.setProperty('--plyr-volume', '0%');
              } else {
                hudElem.className = 'plyr__hud plyr__hud--volumechange';
                hudElem.style.setProperty('--plyr-volume', `${player.volume * 100}%`);
              }
            }, 50);

            window.clearTimeout(hudTimer);
            hudTimer = window.setTimeout(() => {
              player.elements.container.classList.remove('plyr--show-hud');
              previousEvent = '';
            }, 1000);

            previousEvent = 'volumechange';
          });

          if (options.source) {
            player.source = options.source;
          }

          players.push(player);

          if (options.vr) {
            if ('xr' in window.navigator) {
            // Use async/await pattern to handle the Promise properly
              (async () => {
                try {
                  const isSupported = await navigator.xr.isSessionSupported('immersive-vr');

                  if (!isSupported) {
                  // Only initialize VR player if immersive-vr is NOT supported
                    initVRPlayer(player);
                  }
                } catch (error) {
                  console.error('Error checking VR support:', error);
                  // Fallback to 360 player on error
                  initVRPlayer(player);
                }
              })();
            } else {
            // XR API not available, use 360 player
              initVRPlayer(player);
            }
          }

          let position = 0;

          [
            'loadstart',
            'canplay',
            'play',
            'playing',
            'timeupdate',
            'seeking',
            'seeked',
            'pause',
            'waiting',
            'stalled',
            'ended',
            'volumechange',
            'enterfullscreen',
            'exitfullscreen',
          ].forEach((eventName) => {
            player.on(eventName, (e) => {
              const player = e.detail.plyr;

              switch (eventName) {
                default:
                  position = player.currentTime;
                  break;

                case 'volumechange': {
                  position = player.currentTime;

                  const volume = player.volume;
                  const plyrSavedSettings = window.swinger.storage.get('swinger-plyr') || {};
                  plyrSavedSettings.volume = volume;
                  window.swinger.storage.set('swinger-plyr', plyrSavedSettings);

                  players
                    .filter((player) => player.volume !== volume)
                    .forEach((player) => {
                      player.volume = volume;
                    });
                }
                  break;

                case 'ended':
                  position = 0.1;
                  player.currentTime = 0;
                  break;
              }

              window.swinger.eventHub.trigger(wrapper, `swinger-video-player:${eventName}`, e.detail);
            });
          });

          const sendPositionUrl = `${window.swinger.config.apiBase}${window.swinger.config.apiRoutes.trackPlayback}`;
          let lastPositionSent = 0;
          const trackedPlayOnce = {};
          const sendPosition = (positionToSend) => {
            if (positionToSend !== 0 && Math.abs(lastPositionSent - position) < 1) {
              return;
            }

            if (itemOwnState === false) {
              return;
            }

            positionToSend = positionToSend === 0 ? positionToSend : position;
            lastPositionSent = positionToSend;

            console.log('Sending play position', {
              position: positionToSend,
              itemNumber,
              itemOwnState,
            });

            if (window.FormData && window.navigator && navigator.sendBeacon) {
              const data = new FormData();
              data.set('itemNumber', itemNumber);
              data.set('position', positionToSend);

              navigator.sendBeacon(sendPositionUrl, data);
            } else {
              window.swinger.ajax(sendPositionUrl, {
                method: 'POST',
                body: JSON.stringify({
                  itemNumber,
                  position: positionToSend,
                }, null, 4),
              });
            }
          };

          let sendPositionTimer;
          [
            'play',
            'playing',
            'seeked',
            'pause',
            'ended',
          ].forEach((eventName) => {
            player.on(eventName, () => {
              if (!itemNumber || itemOwnState === false) {
                return;
              }

              if (eventName === 'play' && !trackedPlayOnce[itemNumber]) {
                trackedPlayOnce[itemNumber] = true;
                sendPosition(0);

                // Start rent period
                if (window.swinger.user.getItemOwnState(itemNumber) === null) {
                  window.swinger.user.setItemOwnStateStarted(itemNumber);
                }
              } else if (trackedPlayOnce[itemNumber]) {
                window.clearTimeout(sendPositionTimer);
                sendPositionTimer = window.setTimeout(sendPosition, 300);
              }
            });
          });

          window.addEventListener('pagehide', sendPosition);

          player.on('playing', (e) => {
            const player = e.detail.plyr;

            player.elements.container.closest('.swinger-video-player').classList.add('swinger-video-player--has-played');

            if (options.vr) {
              player.vr().camera.aspect = (2 * 16) / 9;
              player.vr().camera.updateProjectionMatrix();
            }
          });

          return player;
        } catch (e) {
          console.error(e);
          return undefined;
        }
      });
      const initFromHTML = (video) => new Promise((resolve) => {
        const wrapper = video.closest('.swinger-video-player');
        const type = wrapper.getAttribute('data-type') || 'video';
        const vr = wrapper.getAttribute('data-vr');
        const standardSources = window.swinger.$('source:not([type^="application/"])', video);
        const standardSource = (() => standardSources.find((standardSource) => (!standardSource.media || window.matchMedia(standardSource.media).matches)
        && (!standardSource.type || canPlayType(standardSource.type))))();
        const qualities = standardSources
          .filter((standardSource) => standardSource.getAttribute('size'))
          .map((standardSource) => Number(standardSource.getAttribute('size')));
        const dashSource = window.swinger.$('source[type^="application/"][type*="dash"]', video)[0];
        const hlsSource = window.swinger.$('source[type^="application/"][type*="mpegurl"]', video)[0];
        const thumbnailSource = window.swinger.$('track[kind="thumbnails"]', video)[0];

        switch (true) {
          default:
            console.log('Loading empty player');
            window.swinger.resourceLoader.script(plyrURL, () => {
              initPlayer({
                type,
                video,
              })
                .then(resolve)
                .catch(console.info);
            });
            break;

          case !standardSource && !!vr:
            console.log('Loading empty VR player');
            window.swinger.resourceLoader.script(plyrURL, () => {
              window.swinger.resourceLoader.script(plyrVrURL, () => {
                initPlayer({
                  type,
                  video,
                  vr,
                })
                  .then(resolve)
                  .catch(console.info);
              });
            });
            break;

          case !!standardSource && !vr:
            if (standardSource) {
              console.log(`Using Standard Source: ${standardSource.type}`);
              window.swinger.resourceLoader.script(plyrURL, () => {
                initPlayer({
                  type,
                  video,
                  thumbnailSource,
                  qualities,
                })
                  .then(resolve)
                  .catch(console.info);
              });
            }
            break;

          case !!standardSource && !!vr:
            if (standardSource) {
              console.log(`Using Standard VR Source: ${standardSource.type}`);
              window.swinger.resourceLoader.script(plyrURL, () => {
                window.swinger.resourceLoader.script(plyrVrURL, () => {
                  initPlayer({
                    type,
                    video,
                    thumbnailSource,
                    qualities,
                    vr,
                  })
                    .then(resolve)
                    .catch(console.info);
                });
              });
            }
            break;

            // HLS: Safari + IE
          case !!hlsSource
        && !!(!hlsSource.media || window.matchMedia(hlsSource.media).matches)
        && !!(canPlayType('application/mpegurl') || canPlayType('application/x-mpegURL') || canPlayType('application/vnd.apple.mpegurl')):
            console.log('Using HLS');
            window.swinger.resourceLoader.script(`${window.swinger.config.assetsBase}/hls/hls.min.js?v=${window.swinger.config.version}`, () => {
              window.swinger.resourceLoader.script(plyrURL, () => {
                initPlayer({
                  type,
                  video,
                  thumbnailSource,
                })
                  .then(resolve)
                  .catch(console.info);

                const hls = new window.Hls();
                hls.loadSource(hlsSource.src);
                hls.attachMedia(video);
              });
            });
            break;

            // DASH: Chromium + Firefox
          case !!dashSource
        && !!(!dashSource.media || window.matchMedia(dashSource.media).matches):
            window.swinger.resourceLoader.script(`${window.swinger.config.assetsBase}/dash/dash.mediaplayer.min.js?v=${window.swinger.config.version}`, () => {
              console.log('Using Dash (Dash.js)');
              const dashPlayer = window.dashjs.MediaPlayer().create();
              dashPlayer.on('qualityChangeRendered', (e) => {
                console.log('qualityChangeRendered', e);
              });
              dashPlayer.updateSettings({
                streaming: {
                  fastSwitchEnabled: true,
                  stableBufferTime: 4,
                  abr: {
                    initialBitrate: { audio: -1, video: 2000 },
                  },
                },
              });
              dashPlayer.initialize(video, dashSource.src, false);

              window.swinger.resourceLoader.script(`${window.swinger.config.assetsBase}/plyr/plyr.js?v=${window.swinger.config.version}`, () => {
                initPlayer({
                  type,
                  video,
                  thumbnailSource,
                })
                  .then(resolve)
                  .catch(console.info);
              });
            });
            break;
        }
      });

      const getOrientation = () => {
        if (window.screen.orientation) {
          if (['landscape', 'landscape-primary', 'landscape-secondary'].indexOf(window.screen.orientation.type) > -1) {
            return 'landscape';
          }
          return 'portrait';
        }
        if (typeof window.orientation !== 'undefined') {
          if (window.orientation === -90 || window.orientation === 90) {
            return 'landscape';
          }
          return 'portrait';
        }
        if (window.matchMedia('(orientation: landscape)').matches) {
          return 'landscape';
        }
        return 'portrait';
      };

      window.swinger.observer.initialize('.swinger-video-player__player', (video) => {
        const wrapper = video.closest('.swinger-video-player');
        const itemNumber = wrapper.getAttribute('data-itemnumber');

        if (
          !window.swinger.user.isLoggedIn()
        || !itemNumber
        || window.swinger.config.productDeliveryType !== 'vod'
        ) {
          initFromHTML(video);
          return;
        }

        window.swinger.api.getItemSources(itemNumber)
          .then((sources) => {
            const qualities = [];
            const source = {
              type: 'video',
            };
            const position = sources.position || 0;
            let previewThumbnailsSrc;

            if (
              sources.tracks
            && Array.isArray(sources.tracks)
            && sources.tracks.findIndex((entry) => entry.kind === 'thumbnails') > -1
            ) {
              const index = sources.tracks.findIndex((entry) => entry.kind === 'thumbnails');

              previewThumbnailsSrc = sources.tracks[index].src;
              // previewThumbnailsSrc = 'https://templates.ffrtz.com/resources/ajax/video-player/thumbnails.vtt';

              source.previewThumbnails = {
                src: previewThumbnailsSrc,
              };
            }

            source.poster = sources.poster && sources.poster.indexOf('nopicture') ? sources.poster : undefined;
            source.sources = sources.sources
              .map((entry) => {
                if (entry.size) {
                  entry.size = Number(entry.size);
                  qualities.push(entry.size);
                }

                if (Array.isArray(entry.src)) {
                  entry.src = entry.src.filter((src) => !src.startsWith('https://vid'));

                  const index = Math.floor(Math.random() * entry.src.length);

                  entry.src = entry.src[index];
                }

                return entry;
              });

            qualities.sort(sortByNumberAsc);
            qualities.reverse();

            const wrapper = video.closest('.swinger-video-player');
            const type = wrapper.getAttribute('data-type') || 'video';
            const vr = wrapper.getAttribute('data-vr');

            const initCallback = () => {
              initPlayer({
                type,
                video,
                source,
                thumbnailSource: {
                  src: previewThumbnailsSrc,
                },
                qualities,
                vr,
                itemNumber,
              })
                .then((player) => {
                  player.once('canplay', () => {
                    const setTime = () => {
                      if (player.currentTime < position) {
                        player.currentTime = position;
                        window.setTimeout(setTime, 200);
                      }
                    };
                    console.log(`Setting player position to ${position}`);
                    setTime();
                  });

                  document.addEventListener('swinger.user:authchange', () => {
                    player.config.i18n.play = getPlayButtonText(itemNumber, type);
                  });
                })
                .catch(console.info);
            };

            window.swinger.resourceLoader.script(plyrURL, () => {
              if (!vr) {
                initCallback();
                return;
              }

              window.swinger.resourceLoader.script(plyrVrURL, () => {
                initCallback();
              });
            });
          })
          .catch(() => {
            console.error('Couldn\'t fetch sources');
            initFromHTML(video);
          });
      }, false);

      window.swinger.observer.initialize('.plyr[tabindex="0"]', (elem) => {
        elem.removeAttribute('tabindex');
      }, false);

      window.swinger.observer.initialize('.plyr__control[data-plyr="play"]', (elem) => {
        const wrapper = elem.closest('.swinger-video-player');
        const itemNumber = wrapper.getAttribute('data-itemnumber');
        const type = wrapper.getAttribute('data-type') || 'video';
        const updateButtonText = () => {
          try {
            elem.ariaLabel = getPlayButtonText(itemNumber, type);
            elem.querySelector('.plyr__sr-only').textContent = getPlayButtonText(itemNumber, type);
          } catch (e) {
          // noop
          }
        };

        document.addEventListener('swinger.user:authchange', () => {
          updateButtonText();
        });

        updateButtonText();
      }, false);

      window.swinger.observer.initialize('.plyr__sr-only', (elem) => {
        elem.setAttribute('inert', '');
      }, false);

      window.swinger.observer.initialize('.plyr__controls', (controls) => {
        if (!window.chrome) {
          return;
        }

        const button = document.createElement('google-cast-launcher');

        controls.appendChild(button);
      }, false);

      window.swinger.observer.initialize('.plyr__control[data-plyr="rewind"] use', (elem) => {
        elem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#swinger-svg-spritesheet-skip-10sec-backwards');
      }, false);

      window.swinger.observer.initialize('.plyr__control[data-plyr="fast-forward"] use', (elem) => {
        elem.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#swinger-svg-spritesheet-skip-10sec-ahead');
      }, false);

      document.addEventListener('swinger-video-player:stop-all', () => {
        window.setTimeout(() => {
          try {
            players
              .filter((player) => player.container && player.container.closest && !player.container.closest('.swinger-compare'))
              .forEach((player) => {
                try {
                  if (player.fullscreen.active) {
                    Promise.resolve(player.fullscreen.exit()).catch((e) => console.log(e));
                  }
                } catch (e) {
                // noop
                }
                player.stop();
              });
          } catch (e) {
          // Safari sometimes fails with a "NotSupportedError: The operation is not supported."
          }
        }, 100);
      });

      document.addEventListener('swinger-video-player:pause-all', () => {
        window.setTimeout(() => {
          players
            .filter((player) => player.elements.container && !player.elements.container.closest('.swinger-compare'))
            .forEach((player) => {
              try {
                if (player.fullscreen.active) {
                  Promise.resolve(player.fullscreen.exit()).catch((e) => console.log(e));
                }
              } catch (e) {
              // noop
              }
              player.pause();
            });
        }, 100);
      });

      document.addEventListener('swinger-video-player:play', (e) => {
        if (!e.detail) {
          return;
        }

        const player = e.detail.plyr;

        if (!player) {
          return;
        }

        activePlayer = player;

        const videoPlayer = activePlayer.elements.container.closest('.swinger-video-player');
        const playPauseControl = videoPlayer.querySelector('[data-plyr="play"]');

        if (playPauseControl) {
          playPauseControl.focus();
        }

        const itemNumber = videoPlayer.getAttribute('data-itemnumber');

        if ('mediaSession' in navigator && itemNumber) {
          window.swinger.api.getItemDetails(itemNumber)
            .then((itemData) => {
              const item = itemData[0];
              const language = window.swinger.config.language;

              if (!item) {
                return;
              }

              const metadata = {
                title: item.name[language] ? item.name[language] : item.name.en,
                // eslint-disable-next-line no-nested-ternary
                artist: item.studio ? item.studio.name : (item.amateur ? item.amateur.name : undefined),
                artwork: [{
                // eslint-disable-next-line no-nested-ternary
                  src: item.image ? (window.swinger.user.isLoggedIn() ? item.image.default : item.image.censored) : undefined,
                }],
              };

              navigator.mediaSession.metadata = new MediaMetadata(metadata);
            })
            .catch(console.info);
        }

        if (
          orientationChangedAtLeastOnce
        && getOrientation() === 'landscape'
        && !activePlayer.fullscreen.active
        ) {
          activePlayer.fullscreen.enter();
        }

        window.setTimeout(() => {
          players
            .filter((currentPlayer) => currentPlayer !== player)
            .filter((player) => player.container && !player.container.closest('.swinger-compare'))
            .forEach((currentPlayer) => {
              currentPlayer.pause();
            });

          player.play();
        }, 100);
      });

      document.addEventListener('click', (e) => {
        const target = window.swinger.eventHub.getTarget(e);
        const googleCastLauncherElem = target.closest('google-cast-launcher');
        const videoPlayerElem = target.closest('.swinger-video-player');

        if (!googleCastLauncherElem || !videoPlayerElem) {
          return;
        }

        const plyrContainer = videoPlayerElem.querySelector('.plyr');

        if (!players.length || !plyrContainer) {
          return;
        }

        const player = players.find((player) => player.elements.container === plyrContainer);

        if (player) {
          window.swinger.eventHub.trigger(videoPlayerElem, 'swinger-video-player:google-cast-launcher', {
            plyr: player,
          });
        }
      }, true);

      document.addEventListener('swinger.overlay:close', (e) => {
        const overlay = e.detail.elem;

        players
          .filter((player) => overlay.contains(player.elements.container))
          .forEach((player) => {
            player.pause();
          });
      });

      const orientationChangeHandler = () => {
        orientationChangedAtLeastOnce = true;

        if (!activePlayer) {
          return;
        }

        const videoElem = activePlayer.elements.container.querySelector('video');

        if (getOrientation() === 'landscape') {
          Promise.resolve(activePlayer.fullscreen.enter()).catch((e) => console.log(e));
          window.setTimeout(() => {
            if (videoElem && !window.screen.orientation && videoElem.webkitDisplayingFullscreen !== undefined) {
              videoElem.webkitEnterFullscreen();
            }
          });
        } else {
          Promise.resolve(activePlayer.fullscreen.exit()).catch((e) => console.log(e));
          window.setTimeout(() => {
            if (videoElem && !window.screen.orientation && videoElem.webkitDisplayingFullscreen !== undefined) {
              videoElem.webkitExitFullscreen();
            }
          });
        }
      };

      if (window.screen.orientation) {
        window.screen.orientation.addEventListener('change', orientationChangeHandler);
      } else {
        window.addEventListener('orientationchange', orientationChangeHandler, false);
      }
    })
    .catch(console.info);

  const controlsVisibleMap = window.WeakMap ? new WeakMap() : new Map();
  window.swinger.observer.initialize('.plyr__controls', (elem) => {
    window.swinger.visibility.observe(elem, (isVisible) => {
      controlsVisibleMap.set(elem, isVisible);
    });
  }, false);

  document.addEventListener('dblclick', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    if (!elem.matches('.plyr__poster')) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  let controlsVisible = true;
  let sequentialClickCount = 0;
  let sequentialClickCountWithControls = 0;
  let sequentialClickTimer;
  // eslint-disable-next-line no-unused-vars
  let previousClickTimestamp = 0;

  document.addEventListener('touchstart', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    if (!elem.matches('.plyr__poster')) {
      return;
    }

    const container = elem.closest('.plyr');
    const controls = container.querySelector('.plyr__controls');

    controlsVisible = controlsVisibleMap.get(controls);
  }, true);

  document.addEventListener('click', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const clickTimestamp = window.performance.now();
    const clickDelay = clickTimestamp - previousClickTimestamp;

    if (!elem.matches('.plyr__poster')) {
      return;
    }

    const player = window.swinger.players.find((player) => player.elements.container.contains(elem));

    if (!player) {
      return;
    }

    sequentialClickCount += 1;

    if (controlsVisible) {
      sequentialClickCountWithControls += 1;
    }

    console.log({
      type: e.type,
      offsetX: e.offsetX,
      elemWidth: elem.getBoundingClientRect().width,
      sequentialClickCount,
      sequentialClickCountWithControls,
      clickDelay: `${clickDelay}ms`,
    });

    previousClickTimestamp = clickTimestamp;

    const elemWidth = elem.getBoundingClientRect().width;
    const clickPosition = e.offsetX;

    switch (true) {
      default:
        break;

      case elem.matches('.swinger-video-player--has-played .plyr__poster') && clickPosition <= (elemWidth / 3):
        player.rewind();
        window.clearTimeout(sequentialClickTimer);
        sequentialClickCount = 0;
        sequentialClickCountWithControls = 0;
        break;

      case elem.matches('.swinger-video-player--has-played .plyr__poster') && clickPosition >= ((elemWidth / 3) * 2):
        player.forward();
        window.clearTimeout(sequentialClickTimer);
        sequentialClickCount = 0;
        sequentialClickCountWithControls = 0;
        break;

      case clickDelay > 300 && sequentialClickCountWithControls % 2 === 1:
        // still allows double click to control fullscreen
        window.clearTimeout(sequentialClickTimer);
        sequentialClickTimer = window.setTimeout(() => {
          if (sequentialClickCountWithControls === 1) {
            player.togglePlay();
          }
          sequentialClickCount = 0;
          sequentialClickCountWithControls = 0;
        }, 300);
        break;

      case elem.matches('.swinger-video-player--has-played .plyr__poster') && clickDelay <= 300 && sequentialClickCount > 1 && sequentialClickCount % 2 === 0:
        window.clearTimeout(sequentialClickTimer);
        sequentialClickCount = 0;
        sequentialClickCountWithControls = 0;
        try {
          player.fullscreen.toggle();
        } catch (e) {
          // noop
        }
        break;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  if ('mediaSession' in navigator) {
    navigator.mediaSession.setActionHandler('play', () => {
      if (typeof activePlayer !== 'undefined') {
        activePlayer.play();
      }
    });
    navigator.mediaSession.setActionHandler('pause', () => {
      if (typeof activePlayer !== 'undefined') {
        activePlayer.pause();
      }
    });
    navigator.mediaSession.setActionHandler('stop', () => {
      if (typeof activePlayer !== 'undefined') {
        activePlayer.stop();
      }
    });
    navigator.mediaSession.setActionHandler('seekbackward', () => {
      if (typeof activePlayer !== 'undefined') {
        activePlayer.rewind();
      }
    });
    navigator.mediaSession.setActionHandler('seekforward', () => {
      if (typeof activePlayer !== 'undefined') {
        activePlayer.forward();
      }
    });
    navigator.mediaSession.setActionHandler('previoustrack', () => {
      if (typeof activePlayer !== 'undefined') {
        activePlayer.rewind();
      }
    });
    navigator.mediaSession.setActionHandler('nexttrack', () => {
      if (typeof activePlayer !== 'undefined') {
        activePlayer.forward();
      }
    });
  }
})();
